import { timeFormat, timeParse } from "d3-time-format"

// Parse and format dates in form 2020-09-28
export const isoDateFormatter = timeFormat("%Y-%m-%d")
export const isoDateParser = timeParse("%Y-%m-%d")
